import type { GetMessagesQuery } from '#src/graphql/generated';

export type MessagesQueryRoot = GetMessagesQuery['messages'][number];

export function buildMessageIdToRootIdMap(
  messages: MessagesQueryRoot[],
): Map<string, string> {
  const map = new Map<string, string>();
  for (const root of messages) {
    map.set(root.id, root.id);
    for (const child of root.childMessages ?? []) {
      map.set(child.id, root.id);
    }
  }
  return map;
}

/**
 * Resolves `focusMessageId` query value to a thread root id using loaded root messages
 * (roots include nested `childMessages`).
 */
export function resolveFocusParamToRootId(
  rawFocusId: string | null,
  messages: MessagesQueryRoot[],
): string | null {
  if (!rawFocusId?.trim()) return null;
  return buildMessageIdToRootIdMap(messages).get(rawFocusId.trim()) ?? null;
}

/** Thread root containing `messageId` (root or direct child), or null if not found. */
export function findThreadRootForMessage(
  roots: MessagesQueryRoot[],
  messageId: string,
): MessagesQueryRoot | null {
  for (const root of roots) {
    if (root.id === messageId) return root;
    for (const child of root.childMessages ?? []) {
      if (child.id === messageId) return root;
    }
  }
  return null;
}
